export default __webpack_public_path__ + "static/0292-39fe1b8f0563b334524a1069ec8989b9.png";